import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import { flexCenter, longBorderDashesStyles, media } from '@anm/styles/helpers';
import styled from 'styled-components';

import { ContentWrapper, HeaderButtonsWrapper } from '../../layouts/LeftBarLayout/Wrapper';

type DropZoneSizes = {
  top: number;
  left: number;
  width: number;
  height: number;
};

type ContentProps = {
  containerWidth?: number;
  scrollDirection: boolean;
};

export const Content = styled(ContentWrapper)<ContentProps>`
  padding: 0;
  display: flex;
  max-width: 100%;
  flex-direction: column;
  min-height: 100vh;
  width: ${({ containerWidth }) => (containerWidth && !isMobileOrIPad() ? `calc(${containerWidth}px - 80px)` : '100%')};
`;

export const DropZone = styled.div`
  position: relative;
  width: 100%;
`;

export const DropZoneBG = styled.div<DropZoneSizes>`
  ${flexCenter};
  ${longBorderDashesStyles};
  z-index: 234;
  position: absolute;
  border-radius: 10px;
  pointer-events: none;
  flex-direction: column;
  background-color: rgba(0, 154, 255, 0.1);
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
`;

export const DropZoneText = styled.span`
  color: #919eaa;
  font-size: 24px;
  font-weight: 700;
  margin-top: 30px;
`;

export const MyVideoHeaderButtonsWrapper = styled(HeaderButtonsWrapper)`
  ${media.phone`min-height: 110px`}
`;
